var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('default-button',{attrs:{"color":_vm.color,"size":"xs","icon":_vm.isLocked ? 'lock-closed' : 'lock-open'},nativeOn:{"click":function($event){return _vm.$emit('click')}}})}
var staticRenderFns = []

export { render, staticRenderFns }